import React from "react";
import { triggerPriceMatchErrors } from "../../useAnalyticsHooks";
import displayConditions, { ELEMENTS } from "../../utils";
import useForm from "../context/useForm";
import Header from "../header/Header";
import Form from "./CustomForm";
import { formElements } from "./elements";
import styles from "./styles.module.scss";

const RequestForm = () => {
  const {
    state: responses,
    handleChange,
    addAttachment,
    removeAttachment,
    setAttachmentError,
    handleFormSubmit,
    serverError,
  } = useForm();
  const shouldDisplay = displayConditions(responses);

  const showButton = shouldDisplay(ELEMENTS.SUBMIT_BUTTON);

  const elements = formElements({ addAttachment, removeAttachment, setAttachmentError, responses, handleChange });

  const triggerErrorCallback = errors => {
    triggerPriceMatchErrors(errors);
  };

  return (
    <div className={styles.formContainer}>
      <Header title={"Your original purchase"}>Your original purchase</Header>
      <Form
        formId={"request-form"}
        id="request-form"
        onSubmit={handleFormSubmit}
        showButton={showButton}
        fields={elements}
        initialValues={responses}
        serverError={serverError}
        errorsCallback={triggerErrorCallback}
      />
    </div>
  );
};

export default RequestForm;
